export default __webpack_public_path__ + "static/bidrequest-6d5b04e94484e6aadb24708cea8a38a5.png";